module.exports = __webpack_public_path__ + "img/2.4883ba5c.jpg";